/* eslint-disable no-unused-vars */
/* jshint esversion: 11 */
import { nodePost } from "@/utils/http.js";

export const checktext = (text) => {
  return nodePost("/toolApi/system/text/textCheck", { text });
};
